import { api } from '../api/index'

const Public = {
  /**
   * @method: ReportBuryingPoint
   * @description: 埋点统计
   * @author: BrandBin
   * @update: 2020-08-26
   * @param {Object} sourceType: '来源点'
   * @return {Object}
   */
  ReportBuryingPoint(object) {
    return new Promise((resolve, reject) => {
      api.reportPublicBuryingPoint(object).then(res => {
        if (res.code === 10000) {
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export {
  Public
}